module.exports = __webpack_public_path__ + "static/media/fly0221.0d2ada7a.webp";